import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../styles/navbar.css";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  /* Lock body scroll when mobile menu is open */
  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const closeMenu = () => setOpen(false);

  /* Scroll helpers */
  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const scrollToSection = (id) => {
    // FŐOLDAL → ALWAYS TOP
    if (id === "top") {
      if (location.pathname !== "/") {
        navigate("/");
        setTimeout(scrollTop, 120);
      } else {
        scrollTop();
      }
      closeMenu();
      return;
    }

    // OTHER SECTIONS
    if (location.pathname !== "/") {
      navigate("/");
      setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
      }, 120);
    } else {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }

    closeMenu();
  };

  const goToContactPage = () => {
    closeMenu();
    navigate("/contact");

    // ensure top of page after route change
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 50);
  };

  const navItems = [
    { label: "Főoldal", id: "top" },
    { label: "Rólunk", id: "rolunk" },
    { label: "Galéria", id: "gallery" },
    { label: "Kapcsolat", id: "contact" },
  ];

  return (
    <>
      {/* HEADER */}
      <header className="ph-nav">
        <div className="ph-container">
          {/* BRAND */}
          <Link to="/" className="ph-brand" aria-label="Főoldal">
            <img
              src="/images/logo.webp"
              alt="Nőként Sikeresen logó"
              className="ph-logo-img"
            />
            <span className="ph-logo-text">
              Nőként<span className="dot">.</span>Sikeresen
            </span>
          </Link>

          {/* DESKTOP NAV */}
          <nav className="ph-desktop">
            <ul className="ph-menu">
              {navItems.map((item) => (
                <li key={item.label}>
                  <button
                    type="button"
                    className="ph-pill"
                    onClick={() => scrollToSection(item.id)}
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>

            <button
              type="button"
              className="ph-pill ph-cta"
              onClick={goToContactPage}
            >
              Jelentkezz most!
            </button>
          </nav>

          {/* BURGER */}
          <button
            className={`ph-burger ${open ? "is-open" : ""}`}
            aria-label="Menü"
            aria-expanded={open}
            onClick={() => setOpen((prev) => !prev)}
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      {/* MOBILE OVERLAY */}
      <div className={`ph-overlay ${open ? "show" : ""}`}>
        <div className="ph-overlay-panel">
          <ul className="ph-overlay-menu">
            {navItems.map((item) => (
              <li key={item.label}>
                <button
                  type="button"
                  className="ph-pill ph-pill-mobile"
                  onClick={() => scrollToSection(item.id)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>

          <button
            type="button"
            className="ph-pill ph-cta ph-pill-mobile"
            onClick={goToContactPage}
          >
            Jelentkezz most!
          </button>
        </div>

        {/* BACKDROP */}
        <button
          className="ph-overlay-backdrop"
          aria-label="Bezárás"
          onClick={closeMenu}
        />
      </div>
    </>
  );
}
